import React from "react";
import Autopara from "../Autopara/Autopara";

const images = [
  "https://images.pexels.com/photos/1181605/pexels-photo-1181605.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
  "https://images.pexels.com/photos/1181619/pexels-photo-1181619.jpeg?cs=srgb&dl=pexels-divinetechygirl-1181619.jpg&fm=jpg",
  "https://img.freepik.com/free-photo/close-up-young-colleagues-having-meeting_23-2149060259.jpg",
];

const paragraphText = `
  <strong>Communication Skills Training</strong> helps learners 
  improve spoken English, public speaking, and professional writing.<br/><br/>
  With role-plays and real-time activities, students gain 
  <span style="color: teal; font-weight: bold;">confidence</span> 
  in presentations, interviews, and workplace communication.
`;

function AutoparaCommunication() {
  return <Autopara images={images} text={paragraphText} />;
}

export default AutoparaCommunication;
